<template>
  <div class="detailSwiper">
    <!-- 即将上架 -->
    <div class="booking" v-if="status==2">
      <i></i>
    </div>
    <!-- 预售 -->
    <div class="booking" v-if="presale==1">
      <i class="icon_presale"></i>
    </div>
    <!-- swiper1 -->
    <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop" @slide-change-transition-start="nowSlide">
      <swiper-slide v-for="(item,index) in imglist" :key="index"><img :src="item"></swiper-slide>
    </swiper>
    <!-- swiper2 Thumbs -->
    <div class="swiperThumbs">
      <ul class="Thumbs" ref="Thumbs" :class="imglist.length>3?'':'Thumbs'+imglist.length">
        <li v-for="(item,index) in imglist" :key="index" :class="thumbs==index?'on':''" @click="small(index)">
          <div><img :src="item+'?imageView2/2/w/90'"></div>
        </li>
      </ul>
      <div @click="slidemove(0)" v-if="imglist.length>3&&thumbs!=0" class="movebtn prev" ref="prev"></div>
      <div @click="slidemove(1)" v-if="imglist.length>3&&thumbs!=imglist.length-1" class="movebtn next" ref="next"></div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'cardswiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      thumbs: 0,
      swiperOptionTop: {
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
      },
    }
  },
  props: {
    imglist: [],
    releaseType: 0,
    presale:'',
    status:''
  },
  mounted() {},
  created() {},
  methods: {
    // 左右切换幻灯片
    slidemove(val) {
      let length = this.$refs.Thumbs.getElementsByTagName('li').length - 1
      let i = this.thumbs;
      if (val == 1) {
        i++
        if (i >= length) {
          i = length
        }
        this.$refs.swiperTop.$swiper.slideTo(i, 500, false);
        this.thumbs = i
        if (i == length) {
          this.$refs.Thumbs.getElementsByTagName('li')[i].style.display = 'inline-block'
          this.$refs.Thumbs.getElementsByTagName('li')[i - 3].style.display = 'none'
        } else {
          if (i >= 2) {
            this.$refs.Thumbs.getElementsByTagName('li')[i + 1].style.display = 'inline-block'
            this.$refs.Thumbs.getElementsByTagName('li')[i - 2].style.display = 'none'
          }
        }
      }
      if (val == 0) {
        i--

        if (i <= 0) {
          i = 0
        }
        this.$refs.swiperTop.$swiper.slideTo(i, 500, false);
        this.thumbs = i
        if (i == 0) {
          this.$refs.Thumbs.getElementsByTagName('li')[i].style.display = 'inline-block'
          this.$refs.Thumbs.getElementsByTagName('li')[i + 3].style.display = 'none'
        } else {
          this.$refs.Thumbs.getElementsByTagName('li')[i - 1].style.display = 'inline-block'
          this.$refs.Thumbs.getElementsByTagName('li')[i + 2].style.display = 'none'
        }
      }

    },
    //幻灯片更改转换开始
    nowSlide() {
      let i = this.$refs.swiperTop.$swiper.activeIndex
      this.thumbs = i
    },
    // 点击切换幻灯片
    small(i) {
      let length = this.$refs.Thumbs.getElementsByTagName('li').length - 1;
      this.$refs.swiperTop.$swiper.slideTo(i, 500, false);
      if (length > 2) {
        if (this.thumbs > i) {
          if (i == 0) {
            this.$refs.Thumbs.getElementsByTagName('li')[i].style.display = 'inline-block'
            this.$refs.Thumbs.getElementsByTagName('li')[i + 3].style.display = 'none'
          } else {
            this.$refs.Thumbs.getElementsByTagName('li')[i - 1].style.display = 'inline-block'
            this.$refs.Thumbs.getElementsByTagName('li')[i + 2].style.display = 'none'
          }
        } else {
          if (i == length) {
            this.$refs.Thumbs.getElementsByTagName('li')[i].style.display = 'inline-block'
            this.$refs.Thumbs.getElementsByTagName('li')[i - 3].style.display = 'none'
          } else {
            if (i >= 2) {
              this.$refs.Thumbs.getElementsByTagName('li')[i + 1].style.display = 'inline-block'
              this.$refs.Thumbs.getElementsByTagName('li')[i - 2].style.display = 'none'
            }
          }
        }
      }
      this.thumbs = i
    }
  }
}

</script>
<style scoped>
.detailSwiper .booking {
  position: absolute;
  width: 70px;
  height: 70px;
  top: 1px;
  left: 1px;
  border-radius: 6px 0 0 0;
  overflow: hidden;
}

.detailSwiper .booking>i {
  width: 0px;
  height: 0px;
  position: absolute;
  top: 0;
  left: 0;
  border-top: 68px solid var(--border-primary);
  border-right: 68px solid transparent;
  z-index: 9;
}


.detailSwiper .booking>i:before {
  content: "即将上架";
  position: absolute;
  top: -61px;
  left: -5px;
  width: 68px;
  color: var(--text-warning);
  font-size: var(--smallsize);
  transform: rotate(-45deg);
}
.detailSwiper .booking>i.icon_presale {
  border-top-color:var(--border-presale);
}
.detailSwiper .booking>i.icon_presale:before {
  content: "预售";
  text-indent: 1em;
}
.gallery-top {
  width: 100%;
  height: 522px;
  background-color: #fff;
  border: 2px solid #F0F0F0;
  border-radius: 8px;
}

.gallery-top .swiper-slide {
  width: 100%;
  height: 522px;
}

.gallery-top .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.swiperThumbs {
  position: relative;
}

/*url(../../../static/images/icon/icon_left.svg)*/
.swiperThumbs .movebtn {
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  position: absolute;
  top: calc(50% - 12px);
  cursor: pointer;
}

.swiperThumbs .movebtn.prev {
  background-image: url(../../../static/images/icon/icon_left.svg);
  left: 100px;
}

.swiperThumbs .movebtn.next {
  background-image: url(../../../static/images/icon/icon_right.svg);
  right: 100px;
}

.Thumbs {
  display: block;
  height: 155px;
  width: 420px;
  overflow: hidden;
  margin: 0 auto;
}

.Thumbs1 {
  width: 140px;
}

.Thumbs2 {
  width: 280px;
}

.Thumbs li {
  width: 90px;
  height: 90px;
  cursor: pointer;
  opacity: .6;
  padding-bottom: 3px;
  border-bottom: 2px solid #C8C8C8;
  margin: 30px 25px;
  display: inline-block;
}

.Thumbs li.on,
.Thumbs li:hover {
  opacity: 1;
  border-bottom-color: #007075;
}

.Thumbs li>div {
  width: 100%;
  height: 100%;
  border: 1.5px solid #F0F0F0;
  border-radius: 4px;
}

.Thumbs li>div img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

</style>



// WEBPACK FOOTER //
// src/components/swiper/card.vue